module.exports = __webpack_public_path__ + "images/bankcard_processing.bf98cee9.png";